import { render } from "./AppDialog.vue?vue&type=template&id=0f4f71d0&scoped=true"
import script from "./AppDialog.vue?vue&type=script&lang=js"
export * from "./AppDialog.vue?vue&type=script&lang=js"

import "./AppDialog.vue?vue&type=style&index=0&id=0f4f71d0&lang=scss&scoped=true"
import "./AppDialog.vue?vue&type=style&index=1&id=0f4f71d0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4f71d0"]])

export default __exports__